import {
  INDEX_ROUTE,
  LOGIN_ROUTE,
  RESTAURANTS_ROUTE,
  RESTAURANTS_ADD_ROUTE,
  RESTAURANTS_EDIT_ROUTE,
  RESTAURANTS_COPY_ROUTE,
  RESTAURANTS_STATISTICS_ROUTE,
  MENU_CATEGORY_ADD_ROUTE,
  MENU_CATEGORY_EDIT_ROUTE,
  MENU_CATEGORY_ROUTE,
  STATISTICS_RRPP_ROUTE,
  TICKETS_ROUTE,
  TICKET_ADD_ROUTE,
  TICKET_EDIT_ROUTE,
  TICKET_TYPES_ROUTE,
  TICKET_TYPE_ADD_ROUTE,
  TICKET_TYPE_EDIT_ROUTE,
  USERS_ROUTE,
  DELIVERYS_ROUTE,
  PLACES_ROUTE,
  PLACES_ADD_ROUTE,
  PLACES_EDIT_ROUTE,
  NOTIFICATIONS_ROUTE,
  NOTIFICATIONS_ADD_ROUTE,
  NOTIFICATIONS_EDIT_ROUTE,
  NEWS_ADD_ROUTE,
  NEWS_EDIT_ROUTE,
  NEWS_ROUTE,
  RESERVATIONS_ROUTE,
  DDJJ_ROUTE
} from "../config/RoutesConstants"
import Roles from "../config/RolesConstants"

let routesXRoles

function getRoutesXRoles(){
  if(!routesXRoles){
    routesXRoles = {}
    routesXRoles[Roles.SUPERADMIN] = [
      INDEX_ROUTE,
      LOGIN_ROUTE,
      RESTAURANTS_ROUTE,
      RESTAURANTS_ADD_ROUTE,
      RESTAURANTS_EDIT_ROUTE,
      RESTAURANTS_COPY_ROUTE,
      RESTAURANTS_STATISTICS_ROUTE,
      MENU_CATEGORY_ADD_ROUTE,
      MENU_CATEGORY_EDIT_ROUTE,
      MENU_CATEGORY_ROUTE,
      STATISTICS_RRPP_ROUTE,
      TICKETS_ROUTE,
      TICKET_ADD_ROUTE,
      TICKET_EDIT_ROUTE,
      TICKET_TYPES_ROUTE,
      TICKET_TYPE_ADD_ROUTE,
      TICKET_TYPE_EDIT_ROUTE,
      USERS_ROUTE,
      DELIVERYS_ROUTE,
      PLACES_ROUTE,
      PLACES_ADD_ROUTE,
      PLACES_EDIT_ROUTE,
      NOTIFICATIONS_ROUTE,
      NOTIFICATIONS_ADD_ROUTE,
      NOTIFICATIONS_EDIT_ROUTE,
      NEWS_ADD_ROUTE,
      NEWS_EDIT_ROUTE,
      NEWS_ROUTE
    ]
    routesXRoles[Roles.ADMIN] = [
      INDEX_ROUTE, 
      LOGIN_ROUTE, 
      USERS_ROUTE, 
      DELIVERYS_ROUTE,
      RESTAURANTS_ROUTE,
      // RESTAURANTS_ADD_ROUTE,
      RESTAURANTS_EDIT_ROUTE,
      // RESTAURANTS_COPY_ROUTE,
      RESTAURANTS_STATISTICS_ROUTE,
      TICKET_TYPES_ROUTE,
      TICKET_TYPE_ADD_ROUTE,
      TICKET_TYPE_EDIT_ROUTE,
      MENU_CATEGORY_ADD_ROUTE,
      MENU_CATEGORY_EDIT_ROUTE,
      MENU_CATEGORY_ROUTE,
      RESERVATIONS_ROUTE,
      DDJJ_ROUTE
    ]
    routesXRoles[Roles.OPERADOR] = [
      INDEX_ROUTE,
      LOGIN_ROUTE,
      RESTAURANTS_ROUTE,
      RESTAURANTS_STATISTICS_ROUTE,
      STATISTICS_RRPP_ROUTE,
      TICKETS_ROUTE,
      TICKET_ADD_ROUTE,
      TICKET_EDIT_ROUTE,
      TICKET_TYPES_ROUTE,
      TICKET_TYPE_ADD_ROUTE,
      TICKET_TYPE_EDIT_ROUTE,
      PLACES_ROUTE,
      PLACES_ADD_ROUTE,
      PLACES_EDIT_ROUTE,
      NOTIFICATIONS_ROUTE,
      NOTIFICATIONS_ADD_ROUTE,
      NOTIFICATIONS_EDIT_ROUTE,
      RESERVATIONS_ROUTE,
      DDJJ_ROUTE
    ]  
    routesXRoles[Roles.REDIMIDOR] = []
    // routesXRoles[Roles.RRPP] = []
    routesXRoles[Roles.DEFAULT] = []
  }
  return routesXRoles
}

export function validateAccess(roles, route){
  if(roles&&route){
    let rXr = getRoutesXRoles() 
    for(let i=0;i<roles.length;i++){
      let rol = roles[i]&&roles[i].id
      // console.log("ROL", rol)
      if(rXr[rol]&&rXr[rol].includes(route)){
        return true
      }
    }
  }
  return false
  
}




// WEBPACK FOOTER //
// ./src/common/ValidateAccess.js